import React from 'react';
import { Link } from 'react-router-dom';
import { BrandLogo } from '../BrandLogo';

const LINKS = [
    { to: '/privacy', label: 'Privacy Policy', testId: 'footer-privacy-link' },
    { to: '/terms', label: 'Terms', testId: 'footer-terms-link' },
    { to: '/contact', label: 'Contact', testId: 'footer-contact-link' },
];

export const SiteFooter = () => (
    <footer className="border-t border-border/50 py-10" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-6 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="space-y-2">
                <BrandLogo size="w-6 h-6" textClass="text-sm" />
                <p className="text-xs text-muted-foreground" style={{ fontFamily: "'Manrope', sans-serif" }}>
                    Built for communities that grow together.
                </p>
            </div>
            <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2 text-sm" style={{ fontFamily: "'Manrope', sans-serif" }}>
                {LINKS.map((l) => (
                    <Link key={l.to} to={l.to} className="text-muted-foreground hover:text-foreground transition-colors" data-testid={l.testId}>
                        {l.label}
                    </Link>
                ))}
            </nav>
            <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} The Room</p>
        </div>
    </footer>
);

export default SiteFooter;
